// extracted by mini-css-extract-plugin
module.exports = {"overview-info-general":"_3-tsXg9YS4","overviewInfoGeneral":"_3-tsXg9YS4","table":"Baa8prGwvx","attributes":"_3w9Qeuzdsh","attributes-entry":"_1B5dDBEcwe","attributesEntry":"_1B5dDBEcwe","last-child":"_3QrIdk03rl","lastChild":"_3QrIdk03rl","key":"_38QfHqx3OP","value":"_1BS8Xsbz_f","tabs":"_2WUhEVhy00","tabs-general":"_1qp2s7ERdj","tabsGeneral":"_1qp2s7ERdj"};
    if(module.hot) {
      // 1614934740730
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  